import React, { Component } from "react";
import NumberFormat from "react-number-format";
import InputMask from "./popup/InputMask";
import TimeDD from "./popup/TimeDD";

class SimpleInputRowSmall extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const { label, mandatory, readOnly, box, type, value, onChange, name } = this.props
        return (
            <div className='grid grid-4x grid-mobile-none gap-15px padding-top-3px margin-bottom-20px'
            style={{flexDirection: 'row', justifyContent:"space-between", alignContent: 'center'}}>
        
                <div className="margin-5px">
                    <div className="txt-site txt-11 txt-main txt-bold">
                        <h4>{label} {mandatory && <span style={{ color: 'red' }}>*</span>}</h4>
                    </div>
                </div>
            <div style={{width:250}}> 
            {box === 'number' ?
                    <NumberFormat
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type="text"
                        className="txt txt-sekunder-color"
                    /> : null
                }

                {box === 'mask' ?
                    <InputMask {...this.props} /> : null
                }

                {box === 'time' ?
                    <TimeDD {...this.props} /> : null
                }

                {box === 'alphaNumericDot' ?
                    <input
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type={type ? type : "text"}
                        className="txt txt-sekunder-color"
                        value={value ?? ""}
                        onChange={(e) => {
                            const re = /^[a-zA-Z0-9\.\s]*$/;
                            if (e.target.value === '' || re.test(e.target.value)) {
                                e.target.value = e.target.value.toUpperCase()
                                onChange(e)
                            }
                        }}
                    /> : null
                }

                {box === 'alphaNumericDash' ?
                    <input
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type={type ? type : "text"}
                        className="txt txt-sekunder-color"
                        value={value ?? ""}
                        onChange={(e) => {
                            const re = /^[a-zA-Z0-9\s-]*$/;
                            if (e.target.value === '' || re.test(e.target.value)) {
                                e.target.value = e.target.value.toUpperCase()
                                onChange(e)
                            }
                        }}
                    /> : null
                }

                {box === 'alphabet' ?
                    <input
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type={type ? type : "text"}
                        className="txt txt-sekunder-color"
                        value={value ?? ""}
                        onChange={(e) => {
                            const re = /^[^0-9!-\/:-@\[-`{-~]*$/;
                            if (e.target.value === '' || re.test(e.target.value)) {
                                e.target.value = e.target.value.toUpperCase()
                                onChange(e)
                            }
                        }}
                    /> : null
                }

                {box === 'onlyNumber' ?
                    <input
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type={type ? type : "text"}
                        className="txt txt-sekunder-color"
                        value={value ?? ""}
                        onChange={(e) => {
                            const re = /^[^a-zA-Z\s!-\/:-@\[-`{-~]*$/;
                            if (e.target.value === '' || re.test(e.target.value)) {
                                onChange(e)
                            }
                        }}
                    /> : null
                }

                {box === 'code' ?
                    <input
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type={type ? type : "text"}
                        className="txt txt-sekunder-color"
                        value={value ?? ""}
                        onChange={(e) => {
                            const re = /^[^\s]*$/;
                            if (e.target.value === '' || re.test(e.target.value)) {
                                e.target.value = e.target.value.toUpperCase()
                                onChange(e)
                            }
                        }}
                    /> : null
                }

                {box === 'lowerCase' ?
                    <input
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type={type ? type : "text"}
                        className="txt txt-sekunder-color"
                        value={value ?? ""}
                        onChange={(e) => {
                            e.target.value = e.target.value.toLowerCase()
                            onChange(e)
                        }}
                    /> : null
                }

                {box === 'alphaNumeric' ?
                    <input
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type={type ? type : "text"}
                        className="txt txt-sekunder-color"
                        value={value ?? ""}
                        onChange={(e) => {
                            const re = /^[a-zA-Z0-9-]*$/;
                            if (e.target.value === '' || re.test(e.target.value)) {
                                e.target.value = e.target.value.toUpperCase()
                                onChange(e)
                            }
                        }}
                    /> : null
                }

                {box === undefined ?
                    <input
                        {...this.props}
                        style={{ backgroundColor: readOnly && "#E6E6E6" }}
                        type={type ? type : "text"}
                        className="txt txt-sekunder-color"
                        value={value ?? ""}
                        onChange={(e) => {
                            e.target.value = e.target.value.toUpperCase()
                            onChange(e)
                        }}

                    /> : null
                }
            </div>
            </div>
        )
    }
}

export default SimpleInputRowSmall